$(document).ready(function(){
	
	// -- Init isotope --
	var $grid = $('.grid').isotope({
		itemSelector: '.grid-item',
		percentPosition: true,
		layoutMode: 'fitRows',
		fitRows: {
		  columnWidth: '.grid-sizer'
		}
	});
	// -- Layout isotope after each image loads --
	$grid.imagesLoaded().progress( function() {
	  $grid.isotope('layout');
	});


	// -- SHOPS --
	// -- Filter isotope --
  var filters = [];
	var checkbox = $('.filter-group .filterLayer');
  
  checkbox.on('change', function(){
  	filters = [];
    getCheckboxValue();
    filters = filters.join(', ');
    // console.log(filters);
    $grid.isotope({ filter: filters });
  });

  function getCheckboxValue(){
	  checkbox.filter(':checked').each(function(){
	    filters.push('.' + this.name);
	  });
  }


  // -- ARTICLES NEWS & MEDIAS --
  // ----------------------------
  var initialFilter = $('.filterByYear').val();
	var $articleListGrid = $('.grid.articles__list').isotope({
		itemSelector: '.grid-item',
		percentPosition: true,
		layoutMode: 'fitRows',
		fitRows: {
		  columnWidth: '.grid-sizer'
		}
	});
	// -- Layout isotope after each image loads --
	$articleListGrid.imagesLoaded().progress( function() {
	  $articleListGrid.isotope('layout');
	}).isotope({ filter: initialFilter });

	// -- Filter isotope --
	$('.filterByYear').on('change', function() {
		var filterValue = this.value;
		$articleListGrid.isotope({ filter: filterValue });
	});



	// -- MEDIAS FILTER BY CRAFT PARAMS --
	$('.filterByYearParams').on('change', function(){
		var currentYear = $(this).val();
		currentYear = currentYear.replace('.','?').replace('-','=');
		var newUrl = window.location.origin + window.location.pathname + currentYear;
		window.location.href = newUrl;
	});

});